import React, { useState, useEffect  } from "react";
import {
  TextField,
  Button,
  Typography,
  Paper,
  Grid,
  InputAdornment,
  Checkbox,
  FormControlLabel,
} from '@mui/material';
import axios from "axios";
import { GoogleOAuthProvider, useGoogleLogin } from '@react-oauth/google';
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import BottomImage from "../../components/LoginPages/bottomimage";
import HeaderApp from "../../components/LoginPages/header";
import "./style.css";
import { loginUser } from "../../store/reducers/authReducer";
import Loader from "../../components/Loader";
import Cookies from "js-cookie";
import { signupUser } from "../../store/reducers/signupSlice";
import { jwtDecode } from "jwt-decode";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const dispatch = useDispatch();
  const { loading, error } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const [helperText, setHelperText] = useState({email: "", password: "", gmailerror:"", loginerror: "" });
  const [errors, setErrors] = useState({email: "", password: "", gmailerror:"", loginerror: "" });
  const [rememberMe, setRememberMe] = useState(false);
  const [loader, setLoader] = useState(false)

  const { user, isAuthenticated } = useSelector((state) => state.auth);
  const CLIENT_ID = "24660824558-kmbv1lh18n9e6urnqgrl32urhpql4in4.apps.googleusercontent.com";

  useEffect(() => {
    window.google?.accounts.id.initialize({
      client_id: CLIENT_ID,
      callback: handleOneTapResponse,
      auto_select: false,
      cancel_on_tap_outside: false,
    });
    window.google?.accounts.id.prompt();
  }, []);

  const handleOneTapResponse = async (response) => {
    try {
      const userObject = jwtDecode(response.credential);
      console.log("One Tap User:", userObject);
      await handleGoogleLogin(userObject);
    } catch (err) {
      console.error("One Tap Login Failed", err);
    }
  };

  const GoogleLoginButton = () => {
    const login = useGoogleLogin({
      onSuccess: (tokenResponse) => {
        fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
          headers: { Authorization: `Bearer ${tokenResponse.access_token}` },
        })
          .then((res) => res.json())
          .then((data) => {
            console.log('User Info:', data); 
            setErrors((prevErrors) => ({
              ...prevErrors,
              gmailerror: "",
              email: ""
            }));
            setHelperText((prevHelperText) => ({
                ...prevHelperText,
                gmailerror: "",
                email: ""
            }));
            handleGoogleLogin(data)})
          .catch((err) => console.error(err));
      },
      onError: () => {
        console.error('Login Failed');
      },
    });

    return (
      <Button onClick={() => login()} variant="outlined" className="googleSignINbtn">
        <img src={`${process.env.PUBLIC_URL}/images/google.png`} alt="Google Logo" style={{ height: 23 }} />
        <span>Login with Google</span>
      </Button>
    );
  };

  const handleGoogleLogin = async (data) => {
    if(data?.email)
    {
      setLoader(true)
      const loginData = {
        email: data.email,
        password: "",
        is_google: true,
        visitor_id: Cookies.get("guid") || "",
      }
      try {
        const result = await dispatch(loginUser(loginData)).unwrap();
        console.log("login ressponse:", result);
        window.google?.accounts.id.cancel();
        setLoader(false)
        navigate("/esign/new-esign");
      } catch (error) {
        setLoader(false)
        console.error("Login failed:", error);
        // debugger;
        if( error?.message=='User does not exist')
        {
          hanndleGoogleSignIn(data);
        }
        else {
          setErrors((prevErrors) => ({
            ...prevErrors,
            gmailerror: error?.message,
          }));
          setHelperText((prevHelperText) => ({
              ...prevHelperText,
              gmailerror: error?.message,
          }));
        }
      }
    }
  };

  const hanndleGoogleSignIn = async (data) => {
    console.log(data)
    setLoader(true)
    if(data?.email)
    {
      const curlPayload = {
        customer_name: data.name,
        gstno: "",
        add1: "",
        add2: "", 
        add3: "", 
        add4: "",
        state: "",
        customer_type: "individual",
        email: data.email,
        mobile: "",
      };
      try {
        const curlResponse = await axios.post(
          "https://invoice.meon.co.in/addcompanyoutside",
          new URLSearchParams(curlPayload),
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              Authorization:
                "Bearer 12A9F8B3C5D6E7F8G9H0J1K2L3M4N5P6Q7R8S9T0U1V2W3X4Y5Z6A7B8C9D0E1F2G3H4",
            },
          }
        );
        if (!curlResponse.data.status) {
          console.log("Failed to add company. Please try again.");
          setLoader(false);
          return;
        }
        // console.log(curlResponse,curlResponse.data.customer_id)
        const { customer_id } = curlResponse.data;

        if (!customer_id) {
          console.log("Customer ID not received. Please try again.");
          setLoader(false);
          return;
        }

        const signupdata = {
          company_email: data?.email,
          company_name: data?.name,
          password: "",
          account_type: "Prepaid",
          admin_type: "user",
          esign_price: "20.00",
          customer_id: customer_id,
          credentials_type: "esign",
          is_google: true,
          visitor_id: Cookies.get("guid") || "",
        }
        try {
          console.log(signupdata)
          const result = await dispatch(signupUser(signupdata)).unwrap();
          console.log("Signup successful:", result);
          window.google?.accounts.id.cancel();
          navigate("/esign/new-esign");
          setLoader(false);
        } catch (error) {
          setLoader(false);
          console.error("Signup failed:", error);
          setErrors((prevErrors) => ({
            ...prevErrors,
            gmailerror: error?.msg,
          }));
          setHelperText((prevHelperText) => ({
              ...prevHelperText,
              gmailerror: error?.msg,
          }));
        }
      } catch (error) {
          setLoader(false)
          console.error("Error verifyotp:", error);
      }
    }
  };

  const validateEmail = (value) => {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailPattern.test(value);
  };

  const validateInputs = () => {
    let newErrors = {email: "", password: "" };
    let newHelperText = {email: "", password: "" };
    let isValid = true;
    
    if (!email) {
      newErrors.email = "Email is required";
      newHelperText.email = "Email is required";
      isValid = false;
    }

    if (!validateEmail(email) && email) {
        newErrors.email = "Invalid email address";
        newHelperText.email = "Invalid email address";
        isValid = false;
    }

    if (!password.trim()) {
        newErrors.password = "Password is required";
        newHelperText.password = "Password is required";
        isValid = false;
    }
    else if (password.length < 8)
    {
        newErrors.password = "Password must be atleast 8 characters.";
        newHelperText.password = "Password must be atleast 8 characters.";
        isValid = false;
    }

    setErrors(newErrors);
    setHelperText(newHelperText);
    return isValid;
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === "email") {
        setEmail(value);
        // Reset error if valid
        if (!validateEmail(value) && value) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                email: "Invalid email address",
                loginerror: "",
                gmailerror: ""
            }));
            setHelperText((prevHelperText) => ({
                ...prevHelperText,
                email: "Invalid email address",
                loginerror: "",
                gmailerror: ""
            }));

        } else {
          setErrors((prevErrors) => ({
            ...prevErrors, email: "", loginerror: "", gmailerror: "", }));
      
          setHelperText((prevHelperText) => ({
            ...prevHelperText, email: "", loginerror: "", gmailerror: "", }));
        }
    }
  };

  const handleSubmit = async () => {
    if (validateInputs()) {
      setLoader(true)
      const loginData = {
        email: email,
        password: password,
        is_google: false,
        visitor_id: Cookies.get("guid") || "",
      }
      try {
        const result = await dispatch(loginUser(loginData)).unwrap();
        console.log("login ressponse:", result);
        window.google?.accounts.id.cancel();
        setLoader(false)
        navigate("/esign/new-esign");
      } catch (error) {
        setLoader(false)
        console.error("login failed:", error);
        setErrors((prevErrors) => ({
          ...prevErrors,
          loginerror: error?.message,
        }));
        setHelperText((prevHelperText) => ({
            ...prevHelperText,
            loginerror: error?.message,
        }));
      }
    }
  };
  
  const handlePasswordToggle = () => {
    setShowPassword((prev) => !prev);
  }
  
  const handleRememberMeChange = (event) => {
    setRememberMe(event.target.checked);
  };
  
  const handleForgotPassword = async () => {
    navigate("/forgot-password");
  }

  
  return (
    <>
      <HeaderApp type='login' />
      <Grid container justifyContent="center" alignItems="center" sx={{display: "flex", position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", zIndex: 1, }}>
        <Grid item xs={12} sm={8} md={3.5}>
          <Paper elevation={3} sx={{ padding: "1.6em 3em", display: 'flex', flexDirection: 'column', alignItems: 'center', background:'#fffff', position: 'relative', zIndex: 1, borderRadius: "15px", boxShadow: "rgba(0, 0, 0, 0.1) 0px 7px 49px 0px" }}>
            <Typography variant="h5" gutterBottom sx={{ fontWeight: 700, fontSize: '24px' }}>
                Let’s get you in!
            </Typography>

            <GoogleOAuthProvider clientId={CLIENT_ID}>
              <GoogleLoginButton />
            </GoogleOAuthProvider>
            {errors.gmailerror && (
              <Typography
                sx={{
                  color: "#FF6666",
                  fontSize: "12px",
                  mt: 0.5,
                  mb: 0,
                  marginRight: "auto"
                }}
              >
                {helperText.gmailerror}
              </Typography>
            )}
            <Typography variant="h5" sx={{ my: 2, color:"#C0C0C0", fontSize: "16px", fontWeight: "400" }}>OR</Typography>

            <TextField
              placeholder="Email address"
              name="email"
              type="email"
              variant="outlined"
              fullWidth
              value={email}
              onChange={(e) => {
                handleChange(e);
              }}
              error={!!errors.email}
              sx={{
                boxSizing: "border-box",
                borderRadius: "10px",
                backgroundColor: "#fff",
                borderColor: "#C0C0C0",
                borderWidth: "5px",
                "& .MuiOutlinedInput-root": {
                  borderColor: errors.email ? "#FF6666" : "#C0C0C0",
                  backgroundColor: errors.email ? "#FFF1F1" : "none",
                  "&:hover fieldset": {
                    borderColor: errors.email ? "#FF6666" : "#C0C0C0",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: errors.email ? "#FF6666" : "#C0C0C0",
                  },
                },
                "& .MuiFormHelperText-root": {
                  color: "#FF6666",
                },
              }}
              InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <img src={`${process.env.PUBLIC_URL}/images/mail.svg`} alt="Email Icon" style={{ width: 18, height: 18 }} />
                    </InputAdornment>
                ),
                sx: { borderRadius: "10px", height: 45, fontSize: "16px", fontWeight: email ? "600" : "400" },
              }}
            />

            {!! errors.email && (
                <Typography
                sx={{
                    color: "#FF6666",
                    fontSize: "12px",
                    mt: 0.5,
                    mb: 0,
                    marginRight: "auto"
                }}
                >
                {helperText.email}
                </Typography>
            )}

            <TextField
              placeholder="Password"
              type={showPassword ? "text" : "password"}
              variant="outlined"
              fullWidth
              value={password}
              onChange={(e) => {
                setPassword(e.target.value)
                setErrors((prevErrors) => ({
                  ...prevErrors, password: "", loginerror: "", gmailerror: "", }));
            
                setHelperText((prevHelperText) => ({
                  ...prevHelperText, password: "", loginerror: "", gmailerror: "", }));
              }}
              error={!!errors.password}
              sx={{
                mt: 2,
                boxSizing: "border-box",
                borderRadius: "10px",
                backgroundColor: "#fff",
                borderColor: "#C0C0C0",
                borderWidth: "5px",
                "& .MuiOutlinedInput-root": {
                  borderColor: errors.password ? "#FF6666" : "#C0C0C0",
                  backgroundColor: errors.password ? "#FFF1F1" : "none",
                  "&:hover fieldset": {
                    borderColor: errors.password ? "#FF6666" : "#C0C0C0",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: errors.password ? "#FF6666" : "#C0C0C0",
                  },
                },
                "& .MuiFormHelperText-root": {
                  color: "#FF6666",
                },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <img src={`${process.env.PUBLIC_URL}/images/lock.svg`} alt="Pass Icon" style={{ width: 18, height: 18 }} />
                  </InputAdornment>
                ),
                endAdornment: (
                    <InputAdornment position="end">
                        <Typography
                            onClick={handlePasswordToggle}
                            sx={{
                                cursor: "pointer",
                                color: "#185CB7",
                                fontSize: "15px",
                                fontWeight: 600,
                                transition: "color 0.2s ease-in-out",
                                textDecoration: "none",
                            }}
                            >
                            {showPassword ? "Hide" : "Show"}
                        </Typography>
                    </InputAdornment>
                ),
                sx: { 
                    borderRadius: "10px",
                    height: 45,
                    fontSize: "16px",
                    fontWeight: password ? "600" : "400",
                    "& input::-ms-reveal, & input::-ms-clear": {
                        display: "none",
                    },
                },
              }}
            />

            {!! errors.password && (
                <Typography
                sx={{
                    color: "#FF6666",
                    fontSize: "12px",
                    mt: 0.5,
                    mb: 0,
                    marginRight: "auto"
                }}
                >
                {helperText.password}
                </Typography>
            )}

            <Grid container alignItems="center" sx={{ mt: 1 }}>
                <Grid item>
                    <FormControlLabel
                    control={
                        <Checkbox
                        checked={rememberMe}
                        onChange={handleRememberMeChange}
                        sx={{ color: "#C0C0C0",
                            "&.Mui-checked": { color: "#185CB7" },
                            "& .MuiSvgIcon-root": {
                                fontSize: 21,
                            },
                            padding: "2em 0 2em 0",
                        }}
                        />
                    }
                    label="Remember me"
                    sx={{
                        color: "#595959",
                        fontSize: "5px",
                        display: "flex",
                        alignItems: "center",
                        gap: "3px",
                        margin: "0",
                        "& .MuiTypography-root": {
                            marginLeft: "0",
                            fontSize: "15px",
                        },
                    }}
                    />
                </Grid>
                <Grid item sx={{ ml: "auto" }}>
                    <Typography
                    sx={{
                        fontSize: "16px",
                        color: "#185CB7",
                        cursor: "pointer",
                        fontWeight: 600,
                        transition: "color 0.2s ease-in-out",
                        "&:hover": { color: "#154A9C" }
                    }}
                    onClick={() => handleForgotPassword()}
                    >
                    Forgot Password?
                    </Typography>
                </Grid>
            </Grid>

            <Button
              variant="contained"
              sx={{
                mt: 1,
                width: '100%',
                height: 45,
                color: "#fff",
                background: "#185CB7",
                textTransform: "none",
                fontSize: "16px",
                borderRadius: "10px",
                fontWeight: "600",
                "&:hover": { background: "#185CB7" },
              }}
              disabled={loading}
              onClick={handleSubmit}
            >
              Login
            </Button>
            {errors.loginerror && (
              <Typography
                sx={{
                  color: "#FF6666",
                  fontSize: "12px",
                  mt: 0.5,
                  mb: 0,
                  marginRight: "auto"
                }}
              >
                {helperText.loginerror}
              </Typography>
            )}
            <Typography sx={{fontSize: "10px", color: "#7F7F7F", my: 2, textAlign: "center", fontWeight: "400"}}>This site is protected by reCAPTCHA and the <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" style={{ color: "#185CB7"}}>Google Privacy Policy</a> and <a href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer" style={{ color: "#185CB7" }}>Terms of Service</a> apply.</Typography>
          </Paper>
        </Grid>
      </Grid>
      <BottomImage />
      {loader && <Loader />}
    </>
  );
};

export default Login;
